import { useEffect, useState } from "react";
import { bookingsStatusColorCode } from "../../utils/statusColor";
import { format } from 'date-fns';
import { calulatedDiscountValue } from "../../utils/summaryCalculation";

type Props = {
  reservationData: any;
}

const SummaryAfterReservationConfrim = ({ reservationData }: Props) => {
  const [statusBg, setStatusBg] = useState<string>("");
  const [statusTextColor, setStatusTextColor] = useState<string>("");

  //Discount
  const [appliedDiscountList, setAppliedDiscountList] = useState<any[]>([
    {
      id: 0,
      discountId: 0,
      discountDefinition: "",
      discountType: "Percentage",
      discountAmount: 0.00,
      discount: 0.00,
      manualDiscount: false,
      discountApplied: false
    },
    {
      id: 0,
      discountId: 0,
      discountDefinition: "Manual Discount",
      discountType: "Amount",
      discountAmount: 0.00,
      discount: 0.00,
      manualDiscount: true,
      discountApplied: false
    }
  ]);

  useEffect(() => {
    if (reservationData) {
      const couponDiscount = reservationData?.reservationDiscount?.find((item: any) => item?.discountId > 0 && !item?.manualDiscount);
      const manualDiscount = reservationData?.reservationDiscount?.find((item: any) => item?.manualDiscount);

      let couponDiscountValue = 0.00;
      if (couponDiscount) {
        couponDiscountValue = calulatedDiscountValue(couponDiscount?.discountAmount, couponDiscount?.discountType, reservationData?.totalBasePriceBeforeDiscount);
      }

      let manualDiscountValue = 0.00;
      if (manualDiscount) {
        manualDiscountValue = calulatedDiscountValue(manualDiscount?.discountAmount, manualDiscount?.discountType, reservationData?.totalBasePriceBeforeDiscount);
      }

      setAppliedDiscountList([
        {
          id: couponDiscount ? couponDiscount?.id : 0,
          discountId: couponDiscount ? couponDiscount?.discountId : 0,
          discountDefinition: couponDiscount ? couponDiscount?.discountDefinition : 0,
          discountType: couponDiscount ? couponDiscount?.discountType : "Percentage",
          discountAmount: couponDiscount ? couponDiscount?.discountAmount : 0.00,
          discount: couponDiscountValue,
          manualDiscount: false,
          discountApplied: couponDiscount ? true : false
        },
        {
          id: manualDiscount ? manualDiscount?.id : 0,
          discountId: 0,
          discountDefinition: manualDiscount ? manualDiscount?.discountDefinition : 0,
          discountType: manualDiscount ? manualDiscount?.discountType : "Amount",
          discountAmount: manualDiscount ? manualDiscount?.discountAmount : 0.00,
          discount: manualDiscountValue,
          manualDiscount: true,
          discountApplied: manualDiscount ? true : false
        }
      ]);
    }
  }, [reservationData])

  useEffect(() => {
    let color = {
      colorBg: "#000000",
      colorText: "#000000"
    };

    color = bookingsStatusColorCode?.find((color: any) => color?.label === reservationData?.status.trim()?.toLowerCase()) || {
      colorBg: "#000000",
      colorText: "#000000"
    };

    setStatusBg(color.colorBg);
    setStatusTextColor(color.colorText);
  }, [reservationData])


  return (
    <div className="w-full">
      <div className={`w-full bg-transparent p-2 flex flex-col gap-1.5 rounded-lg shadow-sm border mt-4 border-[#E4E7EC]`}>
        <div className={`flex justify-between items-center py-4 border-b border-[#E4E7EC]`}>
          <span className={`text-sm font-bold text-[#1D2939]`}>Summary</span>

          <span className={`inline-flex text-xs px-[10px] py-[2px] rounded-xl font-semibold ${statusBg} ${statusTextColor} border border-[#E4E7EC]`}>
            {reservationData?.status || "-"}
          </span>

        </div>

        <div className="flex flex-col gap-1.5 py-2">
          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Branch</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservationData?.branchName || "-"}</span>
          </div>


          <div className="flex flex-col justify-between items-start">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Pickup Date</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservationData?.pickupDate ? format(new Date(reservationData?.pickupDate), "EEEE, MMMM dd, yyyy @ KK:mm a") : ""}</span>
          </div>


          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Pickup Location</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservationData?.pickupLocationName || "-"}</span>
          </div>


          <div className="flex flex-col justify-between items-start">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Return Date</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservationData?.returnDate ? format(new Date(reservationData?.returnDate), "EEEE, MMMM dd, yyyy @ KK:mm a") : ""}</span>
          </div>

          <div className="flex flex-col justify-between items-start mb-4">
            <span className={`text-xs font-medium break-all w-full text-left text-black-rgba`}>Return Location</span>
            <span className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}>{reservationData?.returnLocationName || "-"}</span>
          </div>

          <div className="flex flex-col mb-4">
            <span className={`text-xs font-medium break-all text-left text-black-rgba`}>Vehicle Class</span>

            {
              Array.from(
                new Map(
                  reservationData?.vehicleClassLabels?.map((name: string) => [name?.toLowerCase(), name])
                ).values()
              )?.map((item: any, index: number) => (
                <span
                  key={index}
                  className={`text-xs font-medium break-all w-full text-left text-[#1D2939]`}
                >
                  {(index === 0 ? "" : " -> ") + item}
                </span>
              ))
            }
          </div>

          <div className="flex justify-between gap-x-[0.25rem]">
            <div className="flex-1 flex flex-col justify-between items-start">
              <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>Included Distance</span>
              <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{`${reservationData?.includedMiles} ${reservationData?.includedMiles > 1 ? "miles" : "mile"}`}</span>
            </div>
          </div>

          <hr className={`w-full bg-[#E4E7EC]`} />
          <div className={`pt-2`}>
            <span className={`text-sm font-bold text-[#1D2939]`}>Price Details</span>
          </div>

          <div className="flex flex-col gap-1.5">
            {
              reservationData?.totalMonths !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationData?.totalMonths}x Months</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}> ${reservationData?.monthlyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationData?.totalMonths * reservationData?.monthlyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            {
              reservationData?.totalWeeks !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationData?.totalWeeks}x Weeks</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${reservationData?.weeklyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationData?.totalWeeks * reservationData?.weeklyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            {
              reservationData?.totalDays !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationData?.totalDays}x Days</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${reservationData?.dailyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationData?.totalDays * reservationData?.dailyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            {
              reservationData?.totalHours !== 0 && (
                <div className="flex justify-between items-start w-full">
                  <span className={`text-xs font-medium break-all flex-1 text-left text-[#1D2939]`}>{reservationData?.totalHours}x Hours</span>
                  <span className={`text-xs font-medium break-all flex-1  text-right text-[#1D2939]`}>${reservationData?.hourlyRate?.toFixed(2)}</span>
                  <span className={`text-xs font-medium break-all flex-1 text-right text-[#1D2939]`}>${(reservationData?.totalHours * reservationData?.hourlyRate)?.toFixed(2)}</span>
                </div>
              )
            }

            <hr className={`w-full bg-[#E4E7EC]`} />

            {
              appliedDiscountList
                ?.filter((item: any) => item?.discountApplied)
                ?.map((item: any, index: number) => {
                  return (
                    <div key={index} className="flex justify-between items-center">
                      <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{item?.discountDefinition}:</span>
                      <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>-${parseFloat(item?.discount)?.toFixed(2)}</span>
                    </div>
                  )
                })
            }          

            {
              reservationData?.chargeFuelToClient && reservationData?.fuelLevel > 0 && (
                <div>
                  <span className={`text-sm font-bold text-[#1D2939]`}>Equipment & Services</span>
                  <div className="flex justify-between items-start mb-2">
                    <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>Charge For Fuel {reservationData?.fuelLevel}x:</span>
                    <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${reservationData?.fuelCharge?.toFixed(2)}</span>
                  </div>
                </div>
              )
            }

            {
              reservationData?.additionalCategoryDto
                ?.map((item: any, j: number) => {
                  return (
                    <div key={j}>
                      <span className={`text-sm font-bold text-[#1D2939]`}>{item?.categoryName}</span>

                      {
                        item?.additionalChargesDto?.map((value: any, i: number) => {
                          return (
                            <div key={i} className="flex justify-between items-center mb-2">
                              <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{value?.name} {value?.quantity > 1 ? value?.quantity + "x " : ''}:</span>
                              <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${(value?.quantity * value?.basePrice)?.toFixed(2)}</span>
                            </div>
                          )
                        })
                      }
                    </div>
                  )
                })
            }

            {
              (
                reservationData?.mandatoryAdditionalChargesAmount > 0
                || reservationData?.locationFeePercentage > 0
                || reservationData?.taxPercentage > 0
                || reservationData?.governmentTaxPercentage > 0
              )
              && (
                <div>
                  <span className={`text-sm font-bold text-[#1D2939]`}>Miscellaneous</span>

                  {
                    reservationData?.mandatoryAdditionalChargesAmount > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{reservationData?.mandatoryAdditionalChargesName}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservationData?.mandatoryAdditionalChargesAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }

                  {
                    reservationData?.locationFeePercentage > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{`${reservationData?.locationFeeName} (${reservationData?.locationFeePercentage}%)`}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservationData?.locationFeeAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }

                  {
                    reservationData?.taxPercentage > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{`${reservationData?.taxName} (${reservationData?.taxPercentage}%)`}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservationData?.taxAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }

                  {
                    reservationData?.governmentTaxPercentage > 0 &&
                    (
                      <div className="flex justify-between items-center">
                        <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{`${reservationData?.governmentTaxName} (${reservationData?.governmentTaxPercentage}%)`}:</span>
                        <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(reservationData?.governmentTaxAmount)?.toFixed(2)}</span>
                      </div>
                    )
                  }
                </div>
              )
            }
          </div>

          <hr className={`w-full !mt-2 bg-[#E4E7EC]`} />

          <div className={`flex justify-between items-center py-2`}>
            <span className={`text-sm font-bold text-black-rgba`}>Total</span>
            <span className={`text-sm font-bold text-[#1D2939]`}>${reservationData?.totalPrice?.toFixed(2)}</span>
          </div>

          <hr className={`w-full bg-[#E4E7EC]`} />

          <div className={`flex justify-between items-center py-4`}>
            <span className={`text-sm font-bold text-black-rgba`}>Security Deposit</span>
            <span className={`text-sm font-bold text-red-500`}>${reservationData?.securityDepositAmount ? reservationData?.securityDepositAmount?.toFixed(2) : 0.00}</span>
          </div>

          {
            reservationData?.rentalReservationPayments
              ?.filter((item: any) => item?.paymentType === "Payment")
              ?.length > 0 && (
              <>
                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold text-[#1D2939]`}>Payments</span>
                </div>

                <div className="flex flex-col">
                  {
                    reservationData?.rentalReservationPayments
                      ?.filter((item: any) => item?.paymentType === "Payment")
                      ?.map((item: any, index: number) => {
                        let subHeaderTest = "";

                        if (item?.cClastFourDigit) {
                          subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand} - ${item?.reference || ""}`;
                        } else if (item?.brand) {
                          subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""}`;
                        } else {
                          subHeaderTest = `${item?.reference || ""}`;
                        }

                        return (
                          <div key={index} className="flex justify-between items-center">
                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{subHeaderTest}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                          </div>
                        )
                      })
                  }
                </div>
              </>
            )
          }

          {
            reservationData?.rentalReservationPayments
              ?.filter((item: any) => item?.paymentType === "Security Deposit")
              ?.length > 0 && (
              <>
                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold text-[#1D2939]`}>Security Deposits</span>
                </div>

                <div className="flex flex-col">
                  {
                    reservationData?.rentalReservationPayments
                      ?.filter((item: any) => item?.paymentType === "Security Deposit")
                      ?.map((item: any, index: number) => {
                        let subHeaderTest = "";

                        if (item?.cClastFourDigit) {
                          subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand} - ${item?.reference || ""} (Security Deposit)`;
                        } else if (item?.brand) {
                          subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""} (Security Deposit)`;
                        } else {
                          subHeaderTest = `${item?.reference || ""} (Security Deposit)`;
                        }

                        return (
                          <div key={index} className="flex justify-between items-center mb-2">
                            <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{subHeaderTest}:</span>
                            <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${parseFloat(item?.amount)?.toFixed(2)}</span>
                          </div>
                        )
                      })
                  }
                </div>
              </>
            )
          }

          {
            reservationData?.rentalReservationRefunds?.length > 0 && (
              <>
                <hr className={`w-full bg-[#E4E7EC]`} />

                <div className={`pt-2`}>
                  <span className={`text-sm font-bold text-[#1D2939]`}>Refunds</span>
                </div>

                <div className="flex flex-col">
                  {
                    reservationData?.rentalReservationRefunds?.map((item: any, index: number) => {
                      const isSecurityDepositRefund = item?.refundType === "Security Deposit";
                      let subHeaderTest = "";

                      if (item?.cClastFourDigit) {
                        subHeaderTest = `${item?.cClastFourDigit || ""} ${item?.brand || ""} - ${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                      } else if (item?.brand) {
                        subHeaderTest = `${item?.brand || ""} - ${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                      } else {
                        subHeaderTest = `${item?.reference || ""} ${isSecurityDepositRefund ? "(Security Deposit)" : ""}`;
                      }

                      return (
                        <div key={index} className="flex justify-between items-center mb-2">
                          <span className={`text-xs font-medium break-all flex-1 text-left text-black-rgba`}>{subHeaderTest}:</span>
                          <span className={`text-xs font-medium break-all w-[30%] text-right text-[#1D2939]`}>${Math.abs(parseFloat(item?.amount))?.toFixed(2)}</span>
                        </div>
                      )
                    })
                  }
                </div>
              </>
            )
          }

          <hr className={`w-full bg-[#E4E7EC]`} />

          <div className={`flex justify-between items-center py-2`}>
            <span className={`text-sm font-bold text-black-rgba`}> Outstanding Balance</span>

            <span className={`text-sm font-bold text-[#1D2939]`}> ${reservationData?.outstandingBalance?.toFixed(2) ?? 0.00}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SummaryAfterReservationConfrim